// eslint-disable-next-line import/no-extraneous-dependencies
import FingerprintJS from '@fingerprintjs/fingerprintjs';

let cachedVisitorId = null;

/**
 * Generates a visitor ID using FingerprintJS.
 *
 * @returns {Promise<string>} - Visitor ID string
 */
export const generateVisitorId = async () => {
  if (cachedVisitorId) {
    return cachedVisitorId;
  }

  try {
    const fp = await FingerprintJS.load();
    const result = await fp.get();

    const { visitorId } = result;
    cachedVisitorId = visitorId;

    return visitorId;
    
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error generating visitor ID:', error);
    return null;
  }
};

/**
 * Clears the cached visitor ID.
 * Call this if you need to regenerate the visitor ID.
 */
export const clearVisitorIdCache = () => {
  cachedVisitorId = null;
};

export default generateVisitorId;
